export default "__VITE_ASSET__GEvRixCpjpx7tbL7uYJ6pg__"